var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-alert',{staticClass:"mb-2",attrs:{"message":_vm.alertMessage,"type":"info"}}),_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"single-actions":_vm.singleActions,"group-actions":_vm.groupActions,"export-data-options":_vm.exportDataOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }